import { UsageBidStatusCount } from "@/types/usage";

const UNSET_LABEL = "미지정";
const COMPLETED_KEYWORD = "투찰 완료";
const ABANDONED_KEYWORD = "투찰 포기";

// 상태 라벨 앞의 숫자 기준 오름차순 정렬, 숫자가 없거나 빈 문자열이면 맨 뒤
const getStatusOrder = (status: string) => {
  const order = parseInt(status, 10);
  return Number.isNaN(order) ? Number.MAX_SAFE_INTEGER : order;
};

const getBarColor = (status: string) => {
  if (status.includes(COMPLETED_KEYWORD)) return "#4765B0";
  if (status.includes(ABANDONED_KEYWORD)) return "#BFBFBF";
  return "#A76D6E";
};

type Props = {
  statuses: UsageBidStatusCount[];
  total: number;
};

export default function UsageStatusDistribution({ statuses, total }: Props) {
  const sorted = [...statuses].sort(
    (a, b) => getStatusOrder(a.status) - getStatusOrder(b.status)
  );
  const maxCount = Math.max(...sorted.map((item) => item.count), 1);

  if (sorted.length === 0) {
    return (
      <div className="h-full flex justify-center items-center text-gray-B text-sm">
        표시할 데이터가 없습니다.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 pt-4">
      {sorted.map((item) => {
        const label = item.status === "" ? UNSET_LABEL : item.status;
        const color = getBarColor(item.status);
        const ratio = total > 0 ? Math.round((item.count / total) * 100) : 0;
        return (
          <div key={label} className="flex items-center gap-4 text-sm">
            <div className="w-40 shrink-0 text-gray-A font-semibold truncate">
              {label}
            </div>
            <div className="flex-1 h-4 bg-gray-E rounded-full overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${(item.count / maxCount) * 100}%`,
                  backgroundColor: color,
                }}
              />
            </div>
            <div className="w-24 shrink-0 text-right">
              <span className="font-semibold">
                {item.count.toLocaleString()}건
              </span>
              <span className="ml-1 text-gray-B">({ratio}%)</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
